export default __webpack_public_path__ + "static/media/selected-file-tick.ba117ea7.svg";